import { render } from "./FranchiseComponent.vue?vue&type=template&id=ad8195ac"
import script from "./FranchiseComponent.vue?vue&type=script&lang=js"
export * from "./FranchiseComponent.vue?vue&type=script&lang=js"

import "./FranchiseComponent.vue?vue&type=style&index=0&id=ad8195ac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__